import React from 'react';
import {
  Button,
  Typography,
  Card,
  CardActions,
  CardBody,
  CardMedia,
  CardTitle
} from '@one-thd/sui-atomic-components';

import data from './data';

const TRACKING_PARAM = '?emt=PD_general';

export const ProDeskInfoPods = () => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-3 sui-mt-5" data-component="ProDeskInfoPods">
      <div className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2 lg:sui-grid-cols-4 sui-gap-4">
        {data.map(({ title, description, imageUrl, ctaUrl }) => (
          <Card key={`${title}`}>
            <CardMedia src={imageUrl} alt={title} aspect="wide" />
            <CardTitle header={title} />
            <CardBody>
              <Typography>{description}</Typography>
            </CardBody>
            <CardActions>
              <a
                href={`${ctaUrl}${TRACKING_PARAM}`}
                className="sui-w-full hover:sui-no-underline"
              >
                <Button fullWidth variant="secondary">
                  Learn More
                </Button>
              </a>
            </CardActions>
          </Card>
        ))}
      </div>
    </div>
  );
};

ProDeskInfoPods.displayName = 'ProDeskInfoPods';
